invHdApp.
  factory('Location', ['$http', function ($http) {
    return {
      init: function (data) {
        return $http.post('api/locations', data);
      },
      newLocation: function () {
        return $http.get('api/new-location');
      },
      show: function (e) {
        return $http.get('api/location/' + e);
      },
      saveLocation: function (data) {
        return $http.post('api/save-location', data);
      },
      deleteLocation: function (data) {
        return $http.post('api/delete-location', data);
      },
      updateLocation: function (data) {
        return $http.post('api/update-location', data);
      },
    };
  }]);